import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class HttpCancelService {
  private cancelPendingRequests$ = new Subject<any>();

  constructor() { }

  public cancelPendingRequests() {
    this.cancelPendingRequests$.next(true);
  }

  public onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable();
  }
}